import React, { Component } from 'react';
import { connect } from 'react-redux';
import Preview from './step3/email/Preview';
import { fetchGenericEmails } from "thunks";
import { initCurrentEmailData, setCurrentEmailData } from '../../actions/actions';
import AppLoader from '../common/loader/AppLoader';

class PreviewEmail extends Component {
    state = {
        selectedEmail: null,
        targetType: null,
        language: null,
        settingsId: 41,
    };

    componentDidMount() {
        const queryParams = new URLSearchParams(location.search);
        const targetType = queryParams.get('targetType');
        const language = queryParams.get('language');
        const settingsId = queryParams.get('settingsId') || 41;
        
        this.setState({ 
            targetType,
            language,
            settingsId,
        }, () => {
            this.props.fetchEmails(settingsId);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { emails } = this.props;
        const { targetType, language } = this.state;

        if (prevProps.emails !== emails && targetType && language) {
            const matchedEmail = emails.find(
                email => email.targetType === targetType && email.language === language
            );

            if (matchedEmail) {
                this.setState({ selectedEmail: matchedEmail });
                const currentData = {
                    ...matchedEmail,
                    action: 'PREVIEW',
                };
                this.props.initCurrentEmailData(currentData);
            }
        }
    }

    render() {
        const { selectedEmail } = this.state;

        return (
            <div>
                {selectedEmail ? <Preview isBillingPreview /> : <AppLoader />}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    emails: state.genericEmail.currentSetting?.emails?.items || [],
    currentEmail: state.genericEmail.currentSetting?.currentEmail,
});

const mapDispatchToProps = (dispatch) => ({
    fetchEmails: (settingsId) => dispatch(fetchGenericEmails({ id: settingsId })),
    setCurrentEmailData: (data) => dispatch(setCurrentEmailData(data)),
    initCurrentEmailData: (data) => dispatch(initCurrentEmailData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviewEmail);
